import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'

export const addVitalsSedationScale = (pcr: any): IPcr => {
  try {
    if (pcr?.patient?.patientVitals?.length > 0) {
      pcr.patient.patientVitals.forEach((vital: any) => {
        if (vital && vital.sedationScale === undefined) {
          vital.sedationScale = { totalsCombined: '', selections: [] }
        }
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addVitalsSedationScale: ${error}`)
    throw error
  }
}
